<template>
  <at-stats :icon="icon">
    <template #title>
      <at-skeleton type="label" class="mb-1" />
    </template>
    <template #value>
      <at-skeleton type="input" :mb="0" />
    </template>
  </at-stats>
</template>

<script setup>
  import { AtStats, AtSkeleton } from '@packages/aliftech-ui';

  defineProps({
    icon: {
      type: [String, Object],
      default: '',
    },
  });
</script>
